import { InvoiceProps } from "@/interfaces/invoices_types";
import { InvoiceCard } from "../Cards/InvoiceCard";
import { SectionDivRow } from "./Components/SectionDivRow";
import { SectionDiv } from "./Components/SectionDiv";

type InvoiceSectionProps = {
    sorted_invoices: InvoiceProps[],
    isNewCard: (cardType: string, id: string) => boolean,
    markAsSeen: (cardType: string, id: string) => void
}

export function InvoiceSection(
    { sorted_invoices, isNewCard, markAsSeen }: InvoiceSectionProps
) {
    return (
        <SectionDiv className="">

            <h3 className="mb-3">Invoices:</h3>

            <SectionDivRow>
                {sorted_invoices.length > 0 ? sorted_invoices.map((invoice) => (
                    <InvoiceCard
                        key={invoice.invoice_id}
                        invoice={invoice}
                        isNew={isNewCard('invoice', invoice.invoice_id ?? '')}
                        onView={() => markAsSeen('invoice', invoice.invoice_id ?? '')} />
                ))
                    :
                    <h3>No Invoices at the moment</h3>}
            </SectionDivRow>

        </SectionDiv>
    );
}
